import { useState } from "react";
import { DESENVOLVEDORA } from "@caixaflow/shared";
import { Modal } from "./Modal";

/** Logo da Master Soluti (azul; no tema escuro vira branco pelo CSS). */
export function LogoMasterSoluti({ variante, altura }: { variante: "logotipo" | "simbolo"; altura: number }) {
  return (
    <img
      className="logo-marca"
      src={`/marca/master-soluti-${variante}.png`}
      alt={variante === "logotipo" ? DESENVOLVEDORA.nome : ""}
      height={altura}
      style={{ height: altura, width: "auto" }}
    />
  );
}

const linkSite = { href: DESENVOLVEDORA.site, target: "_blank", rel: "noopener" } as const;

/** Créditos sob o cartão de login e de troca de senha. */
export function CreditosLogin() {
  return (
    <div className="creditos-login">
      <span className="rotulo">Desenvolvido por</span>
      <a {...linkSite} aria-label={`${DESENVOLVEDORA.nome} — abrir o site`}>
        <LogoMasterSoluti variante="logotipo" altura={44} />
      </a>
      <span className="slogan">{DESENVOLVEDORA.slogan}</span>
      <span className="contato">
        <a {...linkSite}>{DESENVOLVEDORA.siteRotulo}</a> ·{" "}
        <a href={`tel:${DESENVOLVEDORA.telefoneE164}`}>{DESENVOLVEDORA.telefone}</a>
      </span>
    </div>
  );
}

/** Rodapé de todas as telas logadas, com a janela "Sobre". */
export function RodapeCreditos() {
  const [aberto, setAberto] = useState(false);
  return (
    <footer className="rodape-creditos">
      <a {...linkSite} className="assinatura">
        <LogoMasterSoluti variante="simbolo" altura={18} />
        <span>
          Desenvolvido por <b>{DESENVOLVEDORA.nome}</b>
        </span>
      </a>
      <span aria-hidden="true">·</span>
      <button type="button" className="link-botao" onClick={() => setAberto(true)}>
        Sobre
      </button>
      <Modal aberto={aberto} titulo="Sobre o sistema" onFechar={() => setAberto(false)}>
        <Sobre />
      </Modal>
    </footer>
  );
}

function Sobre() {
  return (
    <div className="sobre">
      <a {...linkSite} className="sobre-logo" aria-label={`${DESENVOLVEDORA.nome} — abrir o site`}>
        <LogoMasterSoluti variante="logotipo" altura={64} />
      </a>
      <p className="slogan">{DESENVOLVEDORA.slogan}</p>
      <p style={{ margin: 0 }}>
        <b>Master PDV Eventos</b> <span className="mudo">versão {__VERSAO_APP__}</span>
        <br />
        Sistema de vendas, estoque e controle de caixa para eventos, desenvolvido pela {DESENVOLVEDORA.nome}.
      </p>
      <dl className="dados">
        <dt>Empresa</dt>
        <dd>{DESENVOLVEDORA.razaoSocial}</dd>
        <dt>CNPJ</dt>
        <dd>{DESENVOLVEDORA.cnpj}</dd>
        <dt>Telefone</dt>
        <dd>
          <a href={`tel:${DESENVOLVEDORA.telefoneE164}`}>{DESENVOLVEDORA.telefone}</a>
        </dd>
        <dt>Site</dt>
        <dd>
          <a {...linkSite}>{DESENVOLVEDORA.siteRotulo}</a>
        </dd>
      </dl>
    </div>
  );
}
